/**
 * Bridge gun turret that tracks the jet (GDD §3.6, §5). Ported verbatim (concept L566–L575).
 */
import { BoxGeometry, CylinderGeometry, Group, Sprite } from 'three';
import { mesh } from '../../world/geometry.ts';
import type { Materials } from '../materials.ts';

export interface TurretParts {
  head: Group;
  flash: Sprite;
}

export function buildTurret(M: Materials): Group & { userData: TurretParts } {
  const g = new Group();
  mesh(new CylinderGeometry(1.3, 1.6, 0.9, 16), M.dark, 0, 0.45, 0, g);
  const head = new Group();
  head.position.y = 1.25;
  g.add(head);
  mesh(new BoxGeometry(1.9, 1.0, 2.1), M.heli, 0, 0, 0, head);
  for (const o of [-0.38, 0.38]) {
    const b = new CylinderGeometry(0.1, 0.13, 2.8, 8);
    b.rotateX(Math.PI / 2);
    mesh(b, M.dark, o, 0.12, -2.2, head);
  }
  const flash = new Sprite(M.muzzle);
  flash.scale.set(3.2, 3.2, 1);
  flash.position.set(0, 0.12, -3.8);
  flash.visible = false;
  head.add(flash);
  g.userData = { head, flash } satisfies TurretParts;
  return g as Group & { userData: TurretParts };
}
